import React, { FunctionComponent } from 'react';
import { Box, Container, Slide } from '@mui/material';

import { GenerateChartPanelProps } from '../Waterfall/helpers/types';

import TornadoChartCore from './TornadoChartCore';

/**
 * Reports-page host for the Tornado renderer: the Slide/Container chrome the shared Waterfall layout
 * expects, around the host-agnostic TornadoChartCore (which the Executive View hosts directly).
 * Tornado v1 has no Excel download, so no download affordance renders (blobURL is ignored).
 */
const TornadoChartPanel: FunctionComponent<GenerateChartPanelProps> = ({
  data,
  open,
  formatKey,
  outputName,
  columns,
}) => {
  return (
    <Box>
      <Slide direction="right" in={open} mountOnEnter unmountOnExit>
        <Container
          maxWidth={false}
          sx={{
            mb: 2,
            mt: 2,
            pt: 0,
          }}
        >
          <TornadoChartCore
            data={data}
            formatKey={formatKey}
            outputName={outputName}
            columns={columns}
          />
        </Container>
      </Slide>
    </Box>
  );
};

export default TornadoChartPanel;
